'use client';
import Image from 'next/image';
import Button from '../components/ui/Button';
import Link from 'next/link';

const partners = [
  {
    src: "/images/gbs.svg",
    alt: "Global Blockchain Show",
    link: "https://www.globalblockchainshow.com/",
  },
  {
    src: "/images/gais.svg",
    alt: "Global-AI-Show",
    link: "https://www.globalaishow.com/",
  },
  {
    src: "/images/ggs-logo.svg",
    alt: "Global-GamesShow",
    link: "https://www.globalgamesshow.com/",
  },
  {
    src: "/images/rework-logo.svg",
    alt: "rework",
    link: "https://www.re-work.co/",
  },
  {
    src: "/images/corinium-logo-new.webp",
    alt: "corinium",
    link: "https://www.coriniumintelligence.com/",
  },
 
];

const PartnersSection = () => {
  return (
    <section data-component-id="src/app/PartnersSection.tsx:37:4" data-component-path="src/app/PartnersSection.tsx" data-component-line="37" data-component-file="PartnersSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22partners%22%2C%22className%22%3A%22w-full%20bg-black%20py-10%22%7D" id="partners" className="w-full bg-black py-10">
      <div data-component-id="src/app/PartnersSection.tsx:38:6" data-component-path="src/app/PartnersSection.tsx" data-component-line="38" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-%5B1440px%5D%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-20%22%7D" className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-20">
        {/* Heading */}
        <h2 data-component-id="src/app/PartnersSection.tsx:40:8" data-component-path="src/app/PartnersSection.tsx" data-component-line="40" data-component-file="PartnersSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B18px%5D%20text-center%20sm%3Atext-%5B25px%5D%20md%3Atext-%5B30px%5D%20lg%3Atext-5xl%20font-semibold%20text-white%20mb-12%22%2C%22textContent%22%3A%22Past%20Partners%20%26%20Collaborators%22%7D" className="text-[18px] text-center sm:text-[25px] md:text-[30px] lg:text-5xl font-semibold text-white mb-12">
          Past Partners & Collaborators
        </h2>

        {/* Grid of Partner Logos */}
        <div data-component-id="src/app/PartnersSection.tsx:45:8" data-component-path="src/app/PartnersSection.tsx" data-component-line="45" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-2%20md%3Agrid-cols-3%20lg%3Agrid-cols-4%20xl%3Agrid-cols-5%20gap-6%20mb-12%22%7D" className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6 mb-12">
          {partners.map((partner, index) => (
            <div data-component-id="src/app/PartnersSection.tsx:47:12" data-component-path="src/app/PartnersSection.tsx" data-component-line="47" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20h-%5B100px%5D%20flex%20items-center%20justify-center%20bg-%5Blinear-gradient(40deg%2C%23060606_0%25%2C%23000000_70%25%2C_%231B339E_100%25)%5D%20%20rounded-md%20p-2%22%7D"
              key={index}
              className="w-full h-[100px] flex items-center justify-center bg-[linear-gradient(40deg,#060606_0%,#000000_70%,_#1B339E_100%)]  rounded-md p-2"
            >
              {partner.link ? (
                <Link data-component-id="src/app/PartnersSection.tsx:52:16" data-component-path="src/app/PartnersSection.tsx" data-component-line="52" data-component-file="PartnersSection.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%7D" href={partner.link} target="_blank" rel="noopener noreferrer nofollow">
                  <Image data-component-id="src/app/PartnersSection.tsx:53:18" data-component-path="src/app/PartnersSection.tsx" data-component-line="53" data-component-file="PartnersSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-contain%20w-%5B160px%5D%20h-%5B80px%5D%20transition-transform%20duration-200%20hover%3Ascale-105%22%7D"
                    src={partner.src}
                    alt={partner.alt}
                    width={160}
                    height={80}
                    className="object-contain w-[160px] h-[80px] transition-transform duration-200 hover:scale-105"
                    unoptimized
                  />
                </Link>
              ) : (
                <Image data-component-id="src/app/PartnersSection.tsx:63:16" data-component-path="src/app/PartnersSection.tsx" data-component-line="63" data-component-file="PartnersSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-contain%20w-%5B160px%5D%20h-%5B80px%5D%22%7D"
                  src={partner.src}
                  alt={partner.alt}
                  width={160}
                  height={80}
                  className="object-contain w-[160px] h-[80px]"
                  unoptimized
                />
              )}
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div data-component-id="src/app/PartnersSection.tsx:77:8" data-component-path="src/app/PartnersSection.tsx" data-component-line="77" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%22%7D" className="flex justify-center">
          <Link data-component-id="src/app/PartnersSection.tsx:78:10" data-component-path="src/app/PartnersSection.tsx" data-component-line="78" data-component-file="PartnersSection.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22https%3A%2F%2Flu.ma%2FAICapitalConnect%3Fk%3Dc%22%7D" href="https://lu.ma/AICapitalConnect?k=c" target="_blank" rel="noopener noreferrer nofollow">
            <Button data-component-id="src/app/PartnersSection.tsx:79:12" data-component-path="src/app/PartnersSection.tsx" data-component-line="79" data-component-file="PartnersSection.tsx" data-component-name="Button" data-component-content="%7B%22elementName%22%3A%22Button%22%2C%22className%22%3A%22px-7%20py-4%20bg-white%20hover%3Abg-%5B%237243ff%5D%20hover%3Atext-white%20transition-colors%22%7D"
              text="Apply to Partner"
              text_font_size="text-md"
              text_font_weight="font-bold"
              text_line_height="leading-lg"
              text_text_align="center"
              text_color="text-black"
              fill_background_color="#ffffff"
              effect_box_shadow="0px_0px_10px_#7243ff"
              border_border="border border-[#7243ff]"
              border_border_radius="rounded-3xl"
              padding="16px_28px_16px_28px"
              className="px-7 py-4 bg-white hover:bg-[#7243ff] hover:text-white transition-colors"
            />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
